import { render, staticRenderFns } from "./CompanyCenterDetail.vue?vue&type=template&id=4f7503fa&scoped=true&"
import script from "./CompanyCenterDetail.vue?vue&type=script&lang=js&"
export * from "./CompanyCenterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CompanyCenterDetail.vue?vue&type=style&index=0&id=4f7503fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7503fa",
  null
  
)

export default component.exports